var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
    fill: "#E9EBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.209 14H14.792a2.702 2.702 0 0 0-2.682 3.06.542.542 0 0 0 .811.398c.24-.139.511-.21.788-.208h3.857a1.634 1.634 0 0 1 1.54 1.103l.092.297a2.721 2.721 0 0 0 2.57 1.85h12.524c.284 0 .563.075.81.217a.541.541 0 0 0 .815-.468v-3.54A2.708 2.708 0 0 0 33.21 14z",
    fill: "#478EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 17H14.39c-1.318-.002-2.389 1.154-2.391 2.582 0 .116.007.232.021.348.034.284.274.484.536.447a.453.453 0 0 0 .181-.067c.211-.133.452-.202.696-.199h3.408c.616.002 1.162.426 1.362 1.056l.081.284c.33 1.056 1.243 1.768 2.272 1.771h11.067c.251 0 .497.072.715.207.074.047.157.071.242.071.265 0 .479-.232.479-.518v-3.39c0-1.431-1.072-2.592-2.393-2.592z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.65 19.784a2.693 2.693 0 0 0-1.358-.366H21.768a1.634 1.634 0 0 1-1.54-1.103l-.092-.297a2.721 2.721 0 0 0-2.571-1.85h-3.857a2.592 2.592 0 0 0-1.326.35A2.702 2.702 0 0 0 11 18.876v13a2.708 2.708 0 0 0 2.708 2.709h20.584A2.708 2.708 0 0 0 37 31.876v-9.75a2.69 2.69 0 0 0-1.35-2.342z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default ForwardRef;